import { Select, Spin } from "antd";
import List from "devextreme-react/list";
import ArrayStore from "devextreme/data/array_store";
import * as React from "react";
import { useContext, useState } from "react";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { ServiceContext } from "src/services/provider/Service.provider";
import { formatDate } from "src/util/formatDate";
import { formatCurrency } from "src/util/Masks/formatCurrency";
import ITradeBasicInfo from "../ITradeBasicInfo";
import { groupOptions } from "./groupOptions";
import "./style.scss";


interface ITradeListProps {
  setCurrentTrade: React.Dispatch<React.SetStateAction<ITrade>>;
  setLoadingTradeDetail: React.Dispatch<React.SetStateAction<boolean>>;
  tradesList: ITradeBasicInfo[];
  loadingList: boolean;
  showCartorioScheduleDate?: boolean;
  groupBy?: keyof ITradeBasicInfo;
  noDataText?: string;
}

const listAttrs = { class: "list" };

export function TradeList(props: ITradeListProps) {
  const { tradeSearchService } = useContext(ServiceContext);
  const [groupBy, setGroupBy] = useState<keyof ITradeBasicInfo>(props.groupBy ?? "lastUpdate");

  const dataSourceOptions = {
    store: new ArrayStore({ data: props.tradesList, key: "id" }),
    sort: [{ selector: groupBy, desc: true }, "id"],
    group: groupBy,
    searchExpr: ["id", "fullName", "cpfCnpj", "price", "lastUpdate"]
  };

  async function handleListSelectionChange(e) {
    let selectedTrade;

    if (e.addedItems[0]) {
      selectedTrade = e.addedItems[0];
    }
    if (selectedTrade) {
      getSelectedTrade(selectedTrade.id);
    }
  }

  function getSelectedTrade(tradeID: number) {
    props.setLoadingTradeDetail(true);
    tradeSearchService
      .getTradeDetail(tradeID)
      .then(props.setCurrentTrade)
      .catch(() => ShowNotification.Error("Falha na consulta", "Ocorreu um erro durante a consulta. Tente novamente."))
      .finally(() => props.setLoadingTradeDetail(false));
  }

  return (
    <div className="wrapper">
      <PbrSelect name="groupBy" size="large" defaultValue="Agrupar por..." value={groupBy} onChange={e => setGroupBy(e.toString() as keyof ITradeBasicInfo)} showSearch>
        <Select.Option value="Agrupar por..." disabled>
          Agrupar por...
        </Select.Option>
        {groupOptions.map((option, i) => (
          <Select.Option key={`${option.value}-${i}`} value={option.value}>
            {option.description}
          </Select.Option>
        ))}
      </PbrSelect>

      <div className="left-list trade-list">
        <Spin spinning={props.loadingList} tip="Carregando lista...">
          <List
            noDataText={props.noDataText ? props.noDataText : "Sem dados"}
            selectionMode="single"
            dataSource={dataSourceOptions}
            grouped={true}
            selectedItemKeys={[]}
            onSelectionChanged={e => handleListSelectionChange(e)}
            itemRender={RenderListItem(props.showCartorioScheduleDate)}
            groupRender={RenderListGroup}
            elementAttr={listAttrs}
            collapsibleGroups={true}
          />
        </Spin>
      </div>
    </div>
  );
}

const shortenText = (name: string, size: number) => `${name ? name.slice(0, size).trim() : "-"}${name && name.length > size ? "..." : ""}`;

function RenderListGroup(group) {
  const isName = group.key ? group.key.replace(/(\d(\D|))/gm, "").trim() : false;

  return (
    <div className="group-item">
      <span className="group-name">{!isName ? formatDate(group.key) : shortenText(group.key, 26)}</span>
      <span className="group-qtd"> Total: {group.items.length}</span>
    </div>
  );
}
const RenderListItem = (showCartorioScheduleDate: boolean) => (trade: ITradeBasicInfo) => {
  return (
    <div>
      <div className="trade row">
        <div className="col">
          <span className="id-title">Trade ID {trade.id}</span>
          <div className="id">{trade.id}</div>
        </div>
        <div className="col right">
          <div className="price emphasized-text">{formatCurrency(trade.price)}</div>
          <div className="full-name irrelevant-text">{shortenText(trade.fullName, 20)}</div>
          <div className="document irrelevant-text">{trade.cpfCnpj}</div>
        </div>
      </div>
    </div>
  );
};

export default TradeList;



// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/TradeList.tsx